<template>
	<div class="publish-container">
		<el-form ref="phoneRuleForm" hide-required-asterisk inline :model="ruleForm" :rules="rules">
			<el-form-item label="" prop="title" class="fullWidth">
				<div class="contentBox">
					<input class="titleInput" v-model="ruleForm.title" type="text" maxlength="30"
						placeholder="作品名称（2～30个字）" />
				</div>
			</el-form-item>
			<el-form-item label="" prop="content" class="fullWidth">
				<div class="contentBox">
					<textarea class="contentInput" maxlength="200" v-model="ruleForm.content"
						placeholder="作品描述（200字以内）"></textarea>
					<span class="num">{{ruleForm.content.length}}/ 200</span>
				</div>
			</el-form-item>
			<el-form-item label="分类：" prop="cid" class="threeWidth">
				<el-select v-model="ruleForm.cid" class="inputBox" placeholder="请选择位置" clearable>
					<el-option v-for="item in typeOpts" :key="item.id" :label="item.title" :value="item.id" />
				</el-select>
			</el-form-item>
			<el-form-item label="颜色模式：" prop="yanse" class="threeWidth">
				<el-input type="text" v-model="ruleForm.yanse" class="inputBox" placeholder="填写，如RGB"></el-input>
			</el-form-item>
			<el-form-item label="文件格式：" prop="geshi" class="threeWidth">
				<el-input type="text" v-model="ruleForm.geshi" class="inputBox" placeholder="填写，如PSD"></el-input>
			</el-form-item>
			<el-form-item label="尺寸像素：" prop="chicun" class="threeWidth">
				<el-input type="text" v-model="ruleForm.chicun" class="inputBox" placeholder="填写，如175*200px"></el-input>
			</el-form-item>
			<el-form-item label="文件大小：" prop="size" class="threeWidth">
				<el-input type="text" v-model="ruleForm.size" class="inputBox" placeholder="填写，如80M"></el-input>
			</el-form-item>
			<el-form-item label="图片属性：" prop="shuxing" class="threeWidth">
				<el-select v-model="ruleForm.shuxing" class="inputBox" placeholder="请选择位置" clearable>
					<el-option v-for="item in imgAttributeOpts" :key="item.value" :label="item.title"
						:value="item.title" />
				</el-select>
			</el-form-item>
			<el-form-item label="版权说明：" prop="banquan" class="noFullWidth">
				<div class="borderContentBox">
					<textarea class="borderInput" maxlength="200" v-model="ruleForm.banquan"
						placeholder="填写，200字以内"></textarea>
					<span class="num">{{ruleForm.banquan.length}}/ 200</span>
				</div>
			</el-form-item>
			<el-form-item label="作品类型：" prop="img_type" class="threeWidth">
				<el-select v-model="ruleForm.img_type" class="inputBox" placeholder="请选择作品类型" clearable>
					<el-option v-for="item in imgTypeOpts" :key="item.value" :label="item.title" :value="item.value" />
				</el-select>
			</el-form-item>
			<el-form-item label="上架类型：" prop="type" class="threeWidth">
				<el-select v-model="ruleForm.type" class="inputBox" placeholder="请选择上架类型" clearable
					@change="changeType">
					<el-option v-for="item in launchTypeOpts" :key="item.value" :label="item.title"
						:value="item.value" />
				</el-select>
			</el-form-item>
			<el-form-item label="上传作品：" prop="imgList" class="noFullWidth"
				style="border-bottom: .01rem solid #CCCCCC;padding-bottom: .24rem;">
				<div class="imgList">
					<div class="imgItem" v-for="(item,index) in ruleForm.imgList" :key="index">
						<img class="imgItemImg" :src="item" />
						<img class="delete" src="../../assets/Feedback/delete.png"
							@click="ruleForm.imgList.splice(index,1)" />
					</div>
					<div class="addImgBox" @click="uploadPhoto"
						v-if="!ruleForm.img_type || ruleForm.img_type == 2 || (ruleForm.img_type == 1 && ruleForm.imgList.length != 1)">
						<img class="addImg" src="../../assets/Feedback/addImg.png" />
						<div>点击上传</div>
						<div>不超过3M</div>
					</div>
				</div>
			</el-form-item>
			<el-form-item class="fullWidth" prop="yongtu"
				style="border-bottom: .01rem solid #CCCCCC;padding-bottom: .24rem;">
				<div class="priceBox" style="margin-bottom: 0;">
					作品售价
					<div class="addPurpose" @click="addPrice" v-if="!isXianZhi">
						<img class="addImg" src="../../assets/Painter/iconS.png" />
						添加
					</div>
				</div>
				<el-form-item class="fullWidth" style="margin-top: .16rem;" v-for="(item,index) in ruleForm.yongtu"
					:key="index">
					<el-form-item label="用途：" class="threeWidth" :prop="'yongtu[' + index + '].cid'"
						:rules="[{required: true,message: '请选择用途',trigger: 'blur'}]">
						<el-select v-model="item.cid" class="inputBox" placeholder="请选择用途" clearable
							:disabled="ruleForm.type == 2 && item.cid == 1">
							<el-option v-for="item in yongtuOpts" :key="item.id" :label="item.title" :value="item.id" />
						</el-select>
					</el-form-item>
					<el-form-item label="基础售价：" class="threeWidth" :prop="'yongtu[' + index + '].price'"
						:rules="[{required: true,message: '请输入售价',trigger: 'blur'}]">
						<el-input type="text" v-model="item.price" class="inputBox" placeholder="请输入价格"></el-input>
					</el-form-item>
					<el-form-item label="" class="threeWidth" v-if="ruleForm.yongtu.length > 1">
						<img class="deleteImg" src="../../assets/Painter/iconT.png" @click="deletePrice(index)" />
					</el-form-item>
				</el-form-item>
			</el-form-item>
			<el-form-item class="fullWidth" prop="label"
				style="border-bottom: .01rem solid #CCCCCC;padding-bottom: .24rem;">
				<div class="priceBox">
					作品标签
					<div class="addPurpose" @click="selLabel = [...ruleForm.label]; dialogWorkTipsVisible = true">
						<img class="addImg" src="../../assets/Painter/iconS.png" />
						添加
					</div>
				</div>
				<div class="tips">
					<div class="tip" v-for="(item,index) in ruleForm.label" :key="index">
						{{item.title}}
					</div>
				</div>
			</el-form-item>
			<el-form-item class="fullWidth" style="border-bottom: .01rem solid #CCCCCC;padding-bottom: .24rem;">
				<div class="priceBox">
					展示图水印
				</div>
				<el-form-item label="水印选择：" prop="shuiyin" class="threeWidth">
					<el-select v-model="ruleForm.shuiyin" class="inputBox" placeholder="请选择水印选择" clearable>
						<el-option v-for="item in shuiYinOpts" :key="item.id" :label="item.title" :value="item.id" />
					</el-select>
				</el-form-item>
				<el-form-item label="位置设置：" prop="sy_wz" class="threeWidth">
					<el-select v-model="ruleForm.sy_wz" class="inputBox" placeholder="请选择位置" clearable>
						<el-option v-for="item in positionOpts" :key="item.id" :label="item.name" :value="item.name" />
					</el-select>
				</el-form-item>
			</el-form-item>
			<el-form-item class="fullWidth" prop="level"
				style="border-bottom: .01rem solid #CCCCCC;padding-bottom: .24rem;">
				<div class="priceBox">
					作品可购会员身份
					<div class="addPurpose" @click="selLevel = [...ruleForm.level];;dialogLevelVisible = true">
						<img class="addImg" src="../../assets/Painter/iconS.png" />
						添加
					</div>
				</div>
				<div class="tips">
					<div class="tip" v-for="(item,index) in ruleForm.level" :key="index">
						{{item.title}}
					</div>
				</div>
			</el-form-item>
		</el-form>
		<el-button class="submit" type="primary" size="medium" @click="submitPhoneForm('phoneRuleForm')">发布</el-button>
		<el-upload ref="upload" name="image" action="https://ht.daiyuart.com/api.php/set/Other/upload_img"
			:show-file-list="false" :limit="6" multiple :on-success="handlePhotoSuccess">
		</el-upload>
		<el-dialog class="reportDialog" :visible.sync="dialogReportVisible" append-to-body @close="closeReply">
			<div slot="title">
				<div class="dislogTitle">
					水印
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="" prop="img">
						<div class="waterImgList">
							<div class="imgItem" v-for="(item,index) in 10" :key="index">
								<div class="imgBox">
									<img class="waterImg" src="../../assets/Home/placeholder.png" />
									水印名称
								</div>
								<div class="choose">选择</div>
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
			</div>
		</el-dialog>
		<el-dialog class="workTipsDialog" :visible.sync="dialogWorkTipsVisible" append-to-body @close="closeReply">
			<div slot="title">
				<div class="dislogTitle">
					作品标签选择
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="" prop="img">
						<div class="wrokTipsList">
							<div class="workTip ellipsis-1"
								:class="selLabel.findIndex(row=>row.id == item.id) > -1 ? 'workTipSel' : 'workTipNor'"
								v-for="(item,index) in labelOpts" :key="index" @click="chooseLabel(item)">
								{{item.title}}
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium" @click="submitLabel">确认</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog class="levelDialog" :visible.sync="dialogLevelVisible" append-to-body @close="closeReply">
			<div slot="title">
				<div class="dislogTitle">
					作品可购会员身份
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="ruleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="" prop="img">
						<div class="wrokTipsList">
							<div class="workTip ellipsis-1"
								:class="selLevel.findIndex(row=>row.id == item.id) > -1 ? 'workTipSel' : 'workTipNor'"
								v-for="(item,index) in levelOpts" :key="index" @click="chooseLevel(item)">
								{{item.title}}
							</div>
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium" @click="submitLevel">确认</el-button>
				</div>
			</div>
		</el-dialog>
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'提交成功'"
			@clickOk="$router.replace('/works')" v-if="sucPop" />
	</div>
</template>

<script>
	import PopToast from '../../components/PopToast.vue'
	export default {
		components: {
			PopToast
		},
		data() {
			return {
				sucPop: false,
				selLabel: [],
				selLevel: [],
				labelOpts: [], //标签
				levelOpts: [], //会员
				shuiYinOpts: [], //水印
				yongtuOpts: [], //用途
				typeOpts: [], //分类
				imgAttributeOpts: [{
					title: '精品图',
					value: '1'
				}, {
					title: '普通图',
					value: '2'
				}],
				imgTypeOpts: [{
					title: '单张',
					value: '1'
				}, {
					title: '图集',
					value: '2'
				}],
				launchTypeOpts: [{
					title: '限制购买',
					value: '1'
				}, {
					title: '非限制购买',
					value: '2'
				}],
				dialogReportVisible: false,
				dialogWorkTipsVisible: false,
				dialogLevelVisible: false,
				ruleForm: {
					title: '',
					content: '',
					banquan: '',
					cate: '',
					level: [], //身份
					label: [], //标签
					imgList: [],
					yongtu: [{
						price: '',
						cid: '',
					}],
					priceOpts: [{
						price: '',
						purpose: '',
					}],
				},
				rules: {
					title: [{
						required: true,
						message: '请输入作品名称',
						trigger: 'blur'
					}],
					content: [{
						required: true,
						message: '请输入作品描述',
						trigger: 'blur'
					}],
					cid: [{
						required: true,
						message: '请选择分类',
						trigger: 'blur'
					}],
					yanse: [{
						required: true,
						message: '请输入颜色模式',
						trigger: 'blur'
					}],
					geshi: [{
						required: true,
						message: '请输入文件格式',
						trigger: 'blur'
					}],
					chicun: [{
						required: true,
						message: '请输入尺寸像素',
						trigger: 'blur'
					}],
					size: [{
						required: true,
						message: '请输入文件大小',
						trigger: 'blur'
					}],
					shuxing: [{
						required: true,
						message: '请选择图片属性',
						trigger: 'blur'
					}],
					banquan: [{
						required: true,
						message: '请输入版权说明',
						trigger: 'blur'
					}],
					img_type: [{
						required: true,
						message: '请选择作品类型',
						trigger: 'blur'
					}],
					type: [{
						required: true,
						message: '请选择上架类型',
						trigger: 'blur'
					}],
					imgList: [{
						required: true,
						message: '请上传作品',
						trigger: 'blur'
					}],
					shuiyin: [{
						required: true,
						message: '请选择水印',
						trigger: 'blur'
					}],
					sy_wz: [{
						required: true,
						message: '请选择水印位置',
						trigger: 'blur'
					}],
					label: [{
						required: true,
						message: '请选择作品标签',
						trigger: 'blur'
					}],
					level: [{
						required: true,
						message: '请选择作品可购会员身份',
						trigger: 'blur'
					}],
				},
				positionOpts: [{
						id: 1,
						name: '左上',
						value: 'nw'
					},
					{
						id: 2,
						name: '中上',
						value: 'north'
					},
					{
						id: 3,
						name: '右上',
						value: 'ne'
					},
					{
						id: 4,
						name: '左中',
						value: 'west'
					},
					{
						id: 5,
						name: '中部',
						value: 'center'
					},
					{
						id: 6,
						name: '右中',
						value: 'east'
					},
					{
						id: 7,
						name: '左下',
						value: 'sw'
					},
					{
						id: 8,
						name: '中下',
						value: 'south'
					},
					{
						id: 9,
						name: '右下',
						value: 'se'
					},
				],
			}
		},
		computed: {
			isXianZhi() {
				return this.ruleForm.type == 2 ? true : false
			}
		},
		created() {
			this.basicsClassifyList()
			this.basicsLabelList()
			this.shuiyinList()
			this.levelList()
			this.labelList()
		},
		methods: {
			changeType(event) {
				console.log(event)
				if (this.ruleForm.type == 2) {
					this.ruleForm.yongtu = [{
						price: '',
						cid: 1,
					}]
				}
			},
			addPrice() {
				this.ruleForm.yongtu.push({
					price: '',
					cid: '',
				})
			},
			deletePrice(index) {
				this.ruleForm.yongtu.splice(index, 1)
			},
			chooseLevel(item) {
				const findItemIndex = this.selLevel.findIndex(row => row.id == item.id)
				if (findItemIndex > -1) {
					this.selLevel.splice(findItemIndex, 1)
				} else {
					this.selLevel.push(item)
				}
			},
			submitLabel() {
				this.ruleForm.label = [...this.selLabel]
				this.closeReply()
			},
			submitLevel() {
				this.ruleForm.level = [...this.selLevel]
				this.closeReply()
			},
			chooseLabel(item) {
				const findItemIndex = this.selLabel.findIndex(row => row.id == item.id)
				if (findItemIndex > -1) {
					this.selLabel.splice(findItemIndex, 1)
				} else {
					this.selLabel.push(item)
				}
			},
			basicsLabelList() {
				this.$api.post('/Other/classify_list', {
					type: 1
				}).then(res => {
					if (res.code == 1) {
						this.typeOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			basicsClassifyList() {
				this.$api.post('/Other/classify_list', {
					type: 2
				}).then(res => {
					if (res.code == 1) {
						this.yongtuOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			shuiyinList() {
				this.$api.post('/Other/shuiyin_list', {
					type: 2
				}).then(res => {
					if (res.code == 1) {
						this.shuiYinOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			levelList() {
				this.$api.post('/Other/level_list', {
					type: 2
				}).then(res => {
					if (res.code == 1) {
						this.levelOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			labelList() {
				this.$api.post('/Other/label_list', {
					type: 2
				}).then(res => {
					if (res.code == 1) {
						this.labelOpts = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			closeReply() {
				this.dialogLevelVisible = false
				this.dialogWorkTipsVisible = false
			},
			uploadPhoto() {
				this.$refs.upload.$el.querySelector('input').click();
			},
			handlePhotoSuccess(response, file) {
				console.log(file)
				this.ruleForm.imgList.push(response.data)
			},
			submitPhoneForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('/Hua/add_work', {
							id: this.ruleForm.id,
							title: this.ruleForm.title,
							content: this.ruleForm.content,
							cid: this.ruleForm.cid,
							yongtu: this.ruleForm.yongtu,
							yanse: this.ruleForm.yanse,
							chicun: this.ruleForm.chicun,
							size: this.ruleForm.size,
							geshi: this.ruleForm.geshi,
							banquan: this.ruleForm.banquan,
							shuxing: this.ruleForm.shuxing,
							img_type: this.ruleForm.img_type,
							type: this.ruleForm.type,
							banner: this.ruleForm.imgList.join(','),
							label: this.ruleForm.label.map(item => item.title).join(','),
							sy_wz: this.ruleForm.sy_wz,
							shuiyin: this.ruleForm.shuiyin,
							level: this.ruleForm.level.map(item => item.id).join(','),
							img: this.ruleForm.imgList[0],
							is_del: 1,
						}).then(res => {
							if (res.code == 1) {
								this.sucPop = true
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.publish-container {
		margin: .24rem .24rem;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		border-radius: .08rem;
		padding: .32rem .4rem 0;
	}

	.fullWidth {
		width: 100%;

		::v-deep .el-form {
			&-item {
				&__content {
					width: 100%;
				}
			}
		}
	}

	.threeWidth {
		width: 33.33%;

		::v-deep .el-form {
			&-item {
				&__content {
					width: calc(100% - 0.9rem);
				}
			}
		}
	}

	.noFullWidth {
		width: 100%;

		::v-deep .el-form {
			&-item {
				&__content {
					width: calc(100% - 0.9rem);
				}
			}
		}
	}

	.contentBox {
		width: 100%;
		border-bottom: .01rem solid #CCCCCC;
		position: relative;

		.num {
			bottom: .08rem;
			right: .02rem;
			background: #FFFFFF;
			font-weight: 400;
			font-size: .14rem;
			color: #999999;
			position: absolute;
		}
	}

	.borderContentBox {
		padding: .16rem .16rem;
		height: 1.25rem;
		border: .01rem solid #EFD8B8;
		position: relative;

		.num {
			bottom: .12rem;
			right: .12rem;
			background: #FFFFFF;
			font-weight: 400;
			font-size: .14rem;
			color: #999999;
			position: absolute;
		}
	}

	.titleInput {
		width: 100%;
		height: .84rem;
		padding: 0 0;
		border: none;
		border-radius: 0;
		font-weight: 400;
		font-size: .24rem;
	}

	.contentInput {
		width: 100%;
		height: 1.96rem;
		padding: 0 0;
		border: none;
		border-radius: 0;
		font-weight: 400;
		font-size: .16rem;
	}

	.borderInput {
		width: 100%;
		height: 100%;
		padding: 0 0;
		border: none;
		border-radius: 0;
		font-weight: 400;
		font-size: .16rem;
	}

	.imgList {
		display: flex;
		flex-wrap: wrap;

		.imgItem {
			margin-right: .16rem;
			display: flex;
			width: .86rem;
			height: .86rem;
			border-radius: .04rem;
			overflow: hidden;
			position: relative;

			.delete {
				position: absolute;
				top: .05rem;
				right: .05rem;
				width: .14rem;
				height: .14rem;
				cursor: pointer;
			}

			.imgItemImg {
				width: .86rem;
				height: .86rem;
				object-fit: cover;
			}
		}

		.addImgBox {
			width: .86rem;
			height: .86rem;
			border-radius: .04rem;
			background: #FFFFFF;
			border: 1px solid #EFD8B8;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			font-weight: 400;
			font-size: .12rem;
			color: #999999;
			cursor: pointer;
			line-height: .18rem;

			.addImg {
				margin-bottom: .04rem;
				width: .27rem;
				height: .23rem;
			}
		}
	}

	.deleteImg {
		width: .2rem;
		height: .2rem;
		margin-top: .16rem;
		margin-left: .32rem;
		cursor: pointer;
	}

	.priceBox {
		margin-bottom: .16rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-weight: 500;
		font-size: .16rem;
		color: #252525;

		.addPurpose {
			display: flex;
			align-items: center;
			font-weight: 400;
			font-size: .14rem;
			color: #E29358;
			cursor: pointer;

			.addImg {
				width: .16rem;
				height: .16rem;
				margin-right: .04rem;
			}
		}
	}

	.tips {
		margin-top: .12rem;
		display: flex;
		align-items: center;

		.tip {
			margin-right: .1rem;
			height: .26rem;
			padding: 0 .08rem;
			border-radius: .13rem;
			border: .01rem solid #A88653;
			font-weight: 400;
			font-size: .12rem;
			color: #7C3E0B;
			line-height: .26rem;
		}
	}

	.submit {
		margin: .2rem auto 0;
		width: 1.3rem;
		height: .36rem;
		background: #E29358;
		border-radius: .04rem;
		padding: 0 0;
		font-weight: 400;
		font-size: .14rem;
		color: #252525;
		text-align: center;
		line-height: .36rem;
		border: none;
		cursor: pointer;
	}

	::v-deep .el-form {
		&-item {
			margin-right: 0 !important;
			margin-bottom: .2rem;


			&__label {
				padding: 0 .08rem 0 0;
				width: .9rem;
				font-size: .14rem;
				color: #252525;
				line-height: .52rem;
			}

			&__content {
				line-height: unset;

				.el-select {
					width: 100%;
				}

				.el-input {
					width: 100%;

					&__inner {
						width: 100%;
						height: .52rem !important;
						padding: 0.16rem;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						line-height: .52rem !important;
						border: .01rem solid #EFD8B8 !important;
					}

					&__icon {
						width: .25rem;
						height: .52rem;
						line-height: .52rem;
						font-size: .14rem !important;
					}
				}
			}

			&__error {
				font-size: .12rem;
				padding-top: .04rem;
			}
		}
	}

	li {
		font-size: .14rem !important;
		margin-bottom: 0;
	}
</style>
<style lang="scss" scoped>
	.levelDialog {
		::v-deep .el-dialog {
			width: 5.5rem;
			border-radius: .12rem;

			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}

			}

			&__body {
				padding: 0 .24rem;

				.wrokTipsList::-webkit-scrollbar {
					width: 0;
					height: 0;
				}

				/* Firefox */
				.wrokTipsList {
					scrollbar-width: none;
					/* Firefox 隐藏滚动条 */
				}

				/* IE / Edge 老版本 */
				.wrokTipsList {
					-ms-overflow-style: none;
					/* IE11, Edge */
				}

				.wrokTipsList {
					display: flex;
					flex-wrap: wrap;
					max-height: 5rem;
					width: 100%;
					overflow-y: auto;

					.workTip:nth-child(4n) {
						margin-right: 0;
					}

					.workTip {
						margin-right: .24rem;
						margin-bottom: .2rem;
						width: 1.28rem;
						height: .48rem;
						padding: 0 .24rem;
						border-radius: .04rem;
						font-weight: 400;
						font-size: .16rem;
						line-height: .48rem;
						text-align: center;
						cursor: pointer;
					}

					.workTipNor {
						color: #666666;
						border: .01rem solid #CCCCCC;
					}

					.workTipSel {
						color: #E29358;
						border: .01rem solid #E29358;
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: 0 auto;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}

	.workTipsDialog {
		::v-deep .el-dialog {
			width: 6.4rem;
			border-radius: .12rem;

			&__headerbtn {
				top: .24rem;
				right: .24rem;
				font-size: .16rem;
			}

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.wrokTipsList::-webkit-scrollbar {
					width: 0;
					height: 0;
				}

				/* Firefox */
				.wrokTipsList {
					scrollbar-width: none;
					/* Firefox 隐藏滚动条 */
				}

				/* IE / Edge 老版本 */
				.wrokTipsList {
					-ms-overflow-style: none;
					/* IE11, Edge */
				}

				.wrokTipsList {
					display: flex;
					flex-wrap: wrap;
					max-height: 5rem;
					width: 100%;
					overflow-y: auto;

					.workTip:nth-child(4n) {
						margin-right: 0;
					}

					.workTip {
						margin-right: .24rem;
						margin-bottom: .2rem;
						width: 1.28rem;
						height: .48rem;
						padding: 0 .24rem;
						border-radius: .04rem;
						font-weight: 400;
						font-size: .16rem;
						line-height: .48rem;
						text-align: center;
						cursor: pointer;
					}

					.workTipNor {
						color: #666666;
						border: .01rem solid #CCCCCC;
					}

					.workTipSel {
						color: #E29358;
						border: .01rem solid #E29358;
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: 0 auto;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}

	.reportDialog {

		::v-deep .el-dialog {
			width: 5.5rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.waterImgList::-webkit-scrollbar {
					width: 0;
					height: 0;
				}

				/* Firefox */
				.waterImgList {
					scrollbar-width: none;
					/* Firefox 隐藏滚动条 */
				}

				/* IE / Edge 老版本 */
				.waterImgList {
					-ms-overflow-style: none;
					/* IE11, Edge */
				}

				.waterImgList {
					display: flex;
					flex-direction: column;
					max-height: 5.4rem;
					width: 100%;
					overflow-y: auto;

					.imgItem {
						flex-shrink: 0;
						width: 5rem;
						height: .9rem;
						display: flex;
						align-items: center;
						justify-content: space-between;
						border-bottom: .01rem solid #CCCCCC;
						cursor: pointer;

						.imgBox {
							display: flex;
							align-items: center;
							font-weight: 400;
							font-size: .14rem;
							color: #252525;

							.waterImg {
								margin-right: .06rem;
								width: .6rem;
								height: .6rem;
								object-fit: cover;
								border-radius: .04rem;
							}
						}

						.choose {
							width: .56rem;
							height: .34rem;
							background: #E29358;
							border-radius: .04rem;
							font-weight: 500;
							font-size: .12rem;
							color: #252525;
							line-height: .34rem;
							text-align: center;
						}
					}
				}

				.el-form {

					&-item:nth-child(2) {
						align-items: flex-start;

						.el-form-item__label {
							margin-top: .16rem;
						}
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__content {

							.el-textarea {
								&__inner {
									width: 6rem;
									height: 1.6rem;
									background: #FFFFFF;
									border-radius: .04rem;
									border: .01rem solid #EFD8B8;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
								}
							}

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: 0 auto;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}

	.selLabel {
		color: #E29358;
		border: .01rem solid #E29358;
	}

	.norLabel {
		color: #666666;
		border: .01rem solid #CCCCCC;
	}
</style>